import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArticleLabelV2 = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.6666 4.00002H12.6666C12.8434 4.00002 13.013 4.07026 13.138 4.19528C13.2631 4.32031 13.3333 4.48988 13.3333 4.66669V12C13.3333 12.3536 13.1928 12.6928 12.9428 12.9428C12.6927 13.1929 12.3536 13.3334 12 13.3334M12 13.3334C11.6463 13.3334 11.3072 13.1929 11.0572 12.9428C10.8071 12.6928 10.6666 12.3536 10.6666 12V3.33335C10.6666 3.15654 10.5964 2.98697 10.4714 2.86195C10.3463 2.73693 10.1768 2.66669 9.99996 2.66669H3.33329C3.15648 2.66669 2.98691 2.73693 2.86189 2.86195C2.73686 2.98697 2.66663 3.15654 2.66663 3.33335V11.3334C2.66663 11.8638 2.87734 12.3725 3.25241 12.7476C3.62749 13.1226 4.13619 13.3334 4.66663 13.3334H12ZM5.33329 5.33335H7.99996M5.33329 8.00002H7.99996M5.33329 10.6667H7.99996",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgArticleLabelV2;
